import React from 'react';
import { Helmet } from 'react-helmet';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';

const PrivacyPolicy = () => {
    useDocTitle('Privacy Policy | Skyland Web');

    return (
        <>
            <Helmet>
                <title>Privacy Policy | Skyland Web</title>
                <meta
                    name="description"
                    content="Skyland Web's privacy policy, including how we use cookies and third-party advertising services like Google AdSense."
                />
            </Helmet>

            <NavBar />

            <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16 mt-8 text-gray-700">
                <h1 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6">Privacy Policy</h1>
                <p className="mb-6 text-sm text-gray-500">Last updated: {new Date().toLocaleDateString()}</p>

                <p className="mb-6">
                    Skyland Web ("we", "us", or "our") operates skylandweb.com. This page informs you of our
                    policies regarding the collection, use, and disclosure of information when you use our site.
                </p>

                <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-3">Information We Collect</h2>
                <p className="mb-6">
                    We may collect information you voluntarily provide through our contact and consultation forms,
                    such as your name, email address, and phone number, in order to respond to your inquiries.
                </p>

                <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-3">Cookies and Advertising</h2>
                <p className="mb-6">
                    We use Google AdSense to display advertising on our site. Google, as a third-party vendor,
                    uses cookies to serve ads based on your prior visits to this and other websites. Google's use
                    of advertising cookies enables it and its partners to serve ads based on your visit to our
                    site and/or other sites on the Internet.
                </p>
                <p className="mb-6">
                    You may opt out of personalized advertising by visiting{' '}
                    <a
                        href="https://adssettings.google.com"
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-700 underline hover:text-blue-900"
                    >
                        Google Ads Settings
                    </a>
                    .
                </p>

                <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-3">Third-Party Links</h2>
                <p className="mb-6">
                    Our site may contain links to third-party websites. We are not responsible for the privacy
                    practices or content of those sites.
                </p>

                <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-3">Contact Us</h2>
                <p className="mb-6">
                    If you have questions about this Privacy Policy, please contact us through our{' '}
                    <a href="/contact" className="text-blue-700 underline hover:text-blue-900">
                        contact page
                    </a>
                    .
                </p>
            </div>

            <Footer />
        </>
    );
};

export default PrivacyPolicy;
